import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";
import PageInfoWContactInfoEdit from "../../components/PageInfoWContactInfoEdit";
import PageInfoEdit from "../../components/PageInfoEdit";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";
import GalleryEdit from "../../components/GalleryEdit";

const uploadFolderId = '13gHPsZzfoHdXjNWvnbXItg10WUoEkyIC';

export default function Unge() {
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/Unge" >
                <PageHeaderEdit sectionKey="PageHeader" />
                <PageInfoWContactInfoEdit sectionKey="Sec1" />
                <GalleryEdit sectionKey="Gallery"/>
                <PageInfoWContactInfoEdit sectionKey="Sec2" />
                <PageInfoEdit sectionKey="solagratia" />
                <PageInfoWContactInfoEdit sectionKey="u5" />
            </EditPage>
        </UploadFolderIdProvider>
    );
}